import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Details from './pages/Details';
import Gallery from './pages/Gallery';
import Registry from './pages/Registry';
import RSVP from './pages/RSVP';
import { featureFlags } from './config/featureFlags';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/details" element={<Details />} />
          {featureFlags.gallery && <Route path="/gallery" element={<Gallery />} />}
          {featureFlags.registry && <Route path="/registry" element={<Registry />} />}
          {featureFlags.rsvp && <Route path="/rsvp" element={<RSVP />} />}
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
